import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const FULLSCREEN_ROUTES = new Set(['/play']);

function isFullscreenRoute(pathname: string) {
  if (FULLSCREEN_ROUTES.has(pathname)) return true;
  if (/^\/archives\/[^/]+\/play$/.test(pathname)) return true;
  return false;
}

/** Lock body scroll on full-viewport play screens */
export function BodyRouteClass() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.classList.toggle('route-play', isFullscreenRoute(pathname));
    return () => document.body.classList.remove('route-play');
  }, [pathname]);

  return null;
}
